import { Box, Typography } from '@material-ui/core';
import pluralize from 'pluralize';
import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCard, getAlertCardColors } from '../../../../common/cards/alert-card/AlertCard';
import { useRoutesMap } from '../../../../content-blocks/common/useRoutesMaps';
import { useOrgInfo } from '../../../../global/auth/use-org-info/use-org-info';

interface Props {
  taskCount: number;
}

export const JoinBlockedBanner = ({ taskCount }: Props) => {
  const { fixed } = useRoutesMap();
  const org = useOrgInfo();
  const wordActivities = pluralize(org?.menuLabels?.wordActivity || 'Activity').toLowerCase();
  const { darkTextColor, lightTextColor } = getAlertCardColors('warning');

  if (taskCount === 0) {
    return null;
  }

  return (
    <Box paddingTop={2}>
      <AlertCard title='Required tasks incomplete' variant='warning'>
        <Typography variant='subtitle2' style={{ fontSize: '14px', fontWeight: 400, color: lightTextColor }}>
          {`You have ${taskCount} required ${
            taskCount === 1 ? 'task' : 'tasks'
          } to complete before you can join ${wordActivities}.`}
        </Typography>
        <Box>
          <Link to={`/${fixed.route}/my-elements?tab=tasks`} style={{ textDecoration: 'none' }}>
            <Typography
              variant='body2'
              display='inline'
              style={{ textDecoration: 'underline', color: darkTextColor, fontWeight: 700 }}
            >
              Click here
            </Typography>
          </Link>
          <Typography
            variant='subtitle2'
            display='inline'
            style={{ fontSize: '14px', fontWeight: 400, color: lightTextColor }}
          >
            {' to complete'}
          </Typography>
        </Box>
      </AlertCard>
    </Box>
  );
};
